const MARKETING_PARAMS_STORAGE_KEY = 'owl_marketing_params'

const initializeMarketingParams = () => {
  const marketingParams = getMarketingParams(window.location.search)
  if (Object.keys(marketingParams).length > 0) {
    storeMarketingParams(marketingParams)
  }
}

const getMarketingParams = (search: string): Record<string, string> => {
  const marketingParams: Record<string, string> = {}
  const urlParams = new URLSearchParams(search)

  const googleAdsParams = ['gad_source', 'gad_campaignid', 'gclid']

  for (const [key, value] of urlParams.entries()) {
    if (googleAdsParams.includes(key) && value !== undefined && value !== '') {
      marketingParams[key] = value
    }
  }

  return marketingParams
}

const storeMarketingParams = (params: Record<string, string>): void => {
  if (Object.keys(params).length > 0) {
    try {
      sessionStorage.setItem(MARKETING_PARAMS_STORAGE_KEY, JSON.stringify(params))
    } catch (error) {
      console.warn('Failed to store marketing params:', error)
    }
  }
}

const getStoredMarketingParams = (): Record<string, string> => {
  try {
    const stored = sessionStorage.getItem(MARKETING_PARAMS_STORAGE_KEY)

    if (!stored) return {}

    return JSON.parse(stored)
  } catch (error) {
    console.warn('Failed to retrieve marketing params:', error)
    return {}
  }
}

const marketingParamsUtils = {
  initializeMarketingParams,
  getStoredMarketingParams,
}

export default marketingParamsUtils
